











































































































import {
  Component,
  Prop,
  Mixins
} from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import columns from "./columnsProduct";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import _ from "lodash";

class Filter extends PageRequest {
    categoryId:number;
    clientCode:string;
    keyword:string;
    IgnoneIds: any;

}


@Component
export default class EditRole extends Mixins(AbpBase,DateTimeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) codeCurrent: any;
  @Prop({ type: Array , default: null }) listAll: any;

  data: any = [];
  listSelected: any = [];
  clients: any = [];
  Filter: Filter = new Filter();
  categoriesOfClient: [] = [];

  get loading(){
    return this.$store.state.product.loading;
  }

  get pageSize(){
      return this.$store.state.product.pageSize;
  }
  get totalCount(){
      return this.$store.state.product.totalCount;
  }
  get currentPage(){
      return this.$store.state.product.currentPage;
  }

  pageChange(page:number){
      this.$store.commit('product/setCurrentPage',page);
      this.getpage();
  }
  pagesizeChange(pagesize:number){
      this.$store.commit('product/setPageSize',pagesize);
      this.getpage();
  }

  columns = columns;

  onFilter() {
    this.getpage();
  }

  get list(){
    var list = this.listSelected;
    var re = this.$store.state.product.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      if(_.find(list, v=> v.id == item.id))
        item.isSelected = true;
      else
        item.isSelected = false;

      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  onselected(row){
    this.listSelected.push(row)
  }

  cancel() {
    this.$emit("input", false);
  }

  add() {
    this.$emit("save-add", this.listSelected);
  }

  addAll() {
    this.$store.dispatch({
          type:'product/GetAllProduct',
          data: { ...this.Filter, skipCount: 0, maxResultCount:100000 },
      }).then(results => {
        this.$emit("save-add", results);
      })
  }
  
  visibleChange(value: boolean) {
    this.listSelected = [];
    this.Filter = new Filter();
    if (!value) {
      this.$emit("input", value);
    } else {
      this.listSelected =[];
      this.$store.commit('product/setCurrentPage', 1);
      this.getpage();
    }
  }

  async getpage(){  
      this.Filter.maxResultCount=this.pageSize;
      this.Filter.skipCount=(this.currentPage-1)*this.pageSize; 
      this.Filter.IgnoneIds=_.map(this.listAll, v => v['productId']);
      await this.$store.dispatch({
          type:'product/GetAllProduct',
          data:this.Filter,
      })
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.Filter.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.categoriesOfClient = re;
        this.Filter.categoryId = -1;
      });
  }
  async created(){
    this.getClients();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
      });
  }

  onSelect(selection, row) {
    this.listSelected.push(row)
    this.$emit("on-select", selection, row);
  }

  onSelectCancel(selection, row) {
    this.listSelected = _.filter(this.listSelected, v=> v.id != row.id)
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    selection.forEach(row => {
      this.listSelected.push(row)
    });

    this.$emit("on-select-all", selection);
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o.isSelected = true;
      } else {
        o.isSelected = false;
      }
    });
  }
}
